export const REQUIRES_KEYS = [
  `gatsby-source-filesystem`,
  `gatsby-plugin-page-creator`,
]
